export enum CameraState {
    Enabled,
    Disabled
};